export const surchargeAssignment = {
  quote: "quote",
  global: "global",
};
